import { render, staticRenderFns } from "./CartFooter.vue?vue&type=template&id=28a066bc&scoped=true"
import script from "./CartFooter.vue?vue&type=script&lang=js"
export * from "./CartFooter.vue?vue&type=script&lang=js"
import style0 from "./CartFooter.vue?vue&type=style&index=0&id=28a066bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a066bc",
  null
  
)

export default component.exports